export const mockedQuotes = [
  {
    quoteNumber: '210091/001',
    quoteVersion: '23',
    invoicePrice: '3456',
    financeProduct: 'Operating Lease',
    campaignName: 'Upfront 1 + 35',
    totalDepositPercentage: '13%',
    totalDepositEuro: '34 555',
    amountFinanced: '34 555',
    apr: '12',
    term: '36',
    monthlyPayment: '$7,300.00',
    monthlyPaymentValid: '$7,300.00',
    brand: 'Audi',
    model: 'eTron',
    variant: '',
    newUsed: 'new',
    servicePlanPrice: '$7,300.00',
    servicePlanPriceValid: '$7,300.00',
    servicePlan: 'no',
    contractDuration: '36 months',
    paymentType: 'upfront',
    paymentTerm: '',
  },
  {
    quoteNumber: '210091/002',
    quoteVersion: '23',
    invoicePrice: '3456',
    financeProduct: 'Operating Lease',
    campaignName: 'Upfront 1 + 35',
    totalDepositPercentage: '13%',
    totalDepositEuro: '34 555',
    amountFinanced: '34 555',
    apr: '12',
    term: '36',
    monthlyPayment: '$7,300.00',
    monthlyPaymentValid: '$7,300.00',
    brand: 'Audi',
    model: 'eTron',
    variant: '',
    newUsed: 'new',
    servicePlanPrice: '$7,300.00',
    servicePlanPriceValid: '$7,300.00',
    servicePlan: 'no',
    contractDuration: '36 months',
    paymentType: 'upfront',
    paymentTerm: '',
  },
  {
    quoteNumber: '210091/003',
    quoteVersion: '23',
    invoicePrice: '3456',
    financeProduct: 'Operating Lease',
    campaignName: 'Upfront 1 + 35',
    totalDepositPercentage: '13%',
    totalDepositEuro: '34 555',
    amountFinanced: '34 555',
    apr: '12',
    term: '36',
    monthlyPayment: '$7,300.00',
    monthlyPaymentValid: '$7,300.00',
    brand: 'Audi',
    model: 'eTron',
    variant: '',
    newUsed: 'new',
    servicePlanPrice: '$7,300.00',
    servicePlanPriceValid: '$7,300.00',
    servicePlan: 'no',
    contractDuration: '36 months',
    paymentType: 'upfront',
    paymentTerm: '',
  },
];
